export default import.meta.ROLLDOWN_FILE_URL_r0eusGAVA8rUp6jesbNpnA